module.exports = __webpack_public_path__ + "static/media/renegades_robin_hood.9111acca.png";